import React, { useMemo, useState } from "react";
import Navbar from "../components/LandingPageNew/Navbar";
import Footer from "../components/LandingPageNew/Footer";
/**
 * Datenschutzerklärung Page (React + Tailwind)
 * - Premium cards like your Impressum page
 * - Left sticky table-of-contents on desktop
 * - Collapsible sections (accordion) for better UX on long legal text
 */

const SECTIONS = [
  {
    id: "datenschutz-blick",
    title: "1. Datenschutz auf einen Blick",
    blocks: [
      {
        type: "h3",
        text: "Allgemeine Hinweise",
      },
      {
        type: "p",
        text:
          "Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.",
      },
      { type: "h3", text: "Datenerfassung auf dieser Website" },
      { type: "h4", text: "Wer ist verantwortlich für die Datenerfassung auf dieser Website?" },
      {
        type: "p",
        text:
          "Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.",
      },
      { type: "h4", text: "Wie erfassen wir Ihre Daten?" },
      {
        type: "p",
        text:
          "Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.",
      },
      {
        type: "p",
        text:
          "Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.",
      },
      { type: "h4", text: "Wofür nutzen wir Ihre Daten?" },
      {
        type: "p",
        text:
          "Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.",
      },
      { type: "h4", text: "Welche Rechte haben Sie bezüglich Ihrer Daten?" },
      {
        type: "p",
        text:
          "Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.",
      },
      {
        type: "p",
        text:
          "Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.",
      },
      { type: "h3", text: "Analyse-Tools und Tools von Drittanbietern" },
      {
        type: "p",
        text:
          "Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.",
      },
      {
        type: "p",
        text:
          "Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerklärung.",
      },
    ],
  },
  {
    id: "hosting",
    title: "2. Hosting",
    blocks: [
      { type: "h3", text: "Externes Hosting" },
      {
        type: "p",
        text:
          "Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.",
      },
      {
        type: "p",
        text:
          "Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).",
      },
      {
        type: "p",
        text:
          "Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.",
      },
      { type: "h4", text: "Wir setzen folgenden Hoster ein:" },
      {
        type: "address",
        lines: ["Hostpoint AG", "Neue Jonastrasse 60", "8640 Rapperswil-Jona", "Schweiz"],
      },
      { type: "h3", text: "Auftragsverarbeitung" },
      {
        type: "p",
        text:
          "Wir haben einen Vertrag über Auftragsverarbeitung (AVV) mit dem oben genannten Anbieter geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.",
      },
    ],
  },
  {
    id: "allgemeine-hinweise",
    title: "3. Allgemeine Hinweise und Pflichtinformationen",
    blocks: [
      { type: "h3", text: "Datenschutz" },
      {
        type: "p",
        text:
          "Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.",
      },
      {
        type: "p",
        text:
          "Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.",
      },
      {
        type: "p",
        text:
          "Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.",
      },

      { type: "h3", text: "Hinweis zur verantwortlichen Stelle" },
      {
        type: "p",
        text: "Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:",
      },
      { type: "address", lines: ["UNEVA ", "", "Kleine Johannisstr. 19, 28199 Bremen", "Deutschland"] },
      { type: "kv", label: "E-Mail", value: "anfrage@uneva.de", valueType: "email" },
      {
        type: "p",
        text:
          "Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.",
      },

      { type: "h3", text: "Speicherdauer" },
      {
        type: "p",
        text:
          "Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.",
      },

      { type: "h3", text: "Hinweis zur Datenweitergabe in die USA und sonstige Drittstaaten" },
      {
        type: "p",
        text:
          "Wir verwenden unter anderem Tools von Unternehmen mit Sitz in den USA oder sonstigen datenschutzrechtlich nicht sicheren Drittstaaten. Wenn diese Tools aktiv sind, können Ihre personenbezogene Daten in diese Drittstaaten übertragen und dort verarbeitet werden. Wir weisen darauf hin, dass in diesen Ländern kein mit der EU vergleichbares Datenschutzniveau garantiert werden kann. Beispielsweise sind US-Unternehmen dazu verpflichtet, personenbezogene Daten an Sicherheitsbehörden herauszugeben, ohne dass Sie als Betroffener hiergegen gerichtlich vorgehen könnten. Es kann daher nicht ausgeschlossen werden, dass US-Behörden (z.B. Geheimdienste) Ihre auf US-Servern befindlichen Daten zu Überwachungszwecken verarbeiten, auswerten und dauerhaft speichern. Wir haben auf diese Verarbeitungstätigkeiten keinen Einfluss.",
      },

      { type: "h3", text: "Widerruf Ihrer Einwilligung zur Datenverarbeitung" },
      {
        type: "p",
        text:
          "Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.",
      },

      { type: "h3", text: "Widerspruchsrecht (Art. 21 DSGVO)" },
      {
        type: "callout",
        tone: "warn",
        title: "Widerspruch in besonderen Fällen & Direktwerbung",
        text:
          "WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).\n\nWERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).",
      },

      { type: "h3", text: "Beschwerderecht bei der zuständigen Aufsichtsbehörde" },
      {
        type: "p",
        text:
          "Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.",
      },

      { type: "h3", text: "Recht auf Datenübertragbarkeit" },
      {
        type: "p",
        text:
          "Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.",
      },

      { type: "h3", text: "SSL- bzw. TLS-Verschlüsselung" },
      {
        type: "p",
        text:
          "Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.",
      },
      {
        type: "p",
        text:
          "Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.",
      },

      { type: "h3", text: "Auskunft, Löschung und Berichtigung" },
      {
        type: "p",
        text:
          "Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.",
      },

      { type: "h3", text: "Recht auf Einschränkung der Verarbeitung" },
      {
        type: "list",
        items: [
          "Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.",
          "Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen.",
          "Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.",
          "Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.",
          "Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet werden.",
        ],
      },

      { type: "h3", text: "Widerspruch gegen Werbe-E-Mails" },
      {
        type: "p",
        text:
          "Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.",
      },
    ],
  },

  {
    id: "datenerfassung",
    title: "4. Datenerfassung auf dieser Website",
    blocks: [
      { type: "h3", text: "Cookies" },
      {
        type: "p",
        text:
          "Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.",
      },
      {
        type: "p",
        text:
          "Teilweise können auch Cookies von Drittunternehmen auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Seite betreten (Third-Party-Cookies). Diese ermöglichen uns oder Ihnen die Nutzung bestimmter Dienstleistungen des Drittunternehmens (z.B. Cookies zur Abwicklung von Zahlungsdienstleistungen).",
      },
      {
        type: "p",
        text:
          "Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren würden (z.B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies dienen dazu, das Nutzerverhalten auszuwerten oder Werbung anzuzeigen.",
      },
      {
        type: "p",
        text:
          "Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs (notwendige Cookies) oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (funktionale Cookies, z.B. für die Warenkorbfunktion) oder zur Optimierung der Website (z.B. Cookies zur Messung des Webpublikums) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies abgefragt wurde, erfolgt die Speicherung der betreffenden Cookies ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung ist jederzeit widerrufbar.",
      },
      {
        type: "p",
        text:
          "Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.",
      },
      {
        type: "p",
        text:
          "Soweit Cookies von Drittunternehmen oder zu Analysezwecken eingesetzt werden, werden wir Sie hierüber im Rahmen dieser Datenschutzerklärung gesondert informieren und ggf. eine Einwilligung abfragen.",
      },

      { type: "h3", text: "Server-Log-Dateien" },
      {
        type: "p",
        text:
          "Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:",
      },
      {
        type: "list",
        items: [
          "Browsertyp und Browserversion",
          "verwendetes Betriebssystem",
          "Referrer URL",
          "Hostname des zugreifenden Rechners",
          "Uhrzeit der Serveranfrage",
          "IP-Adresse",
        ],
      },
      {
        type: "p",
        text:
          "Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.",
      },
      {
        type: "p",
        text:
          "Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.",
      },

      { type: "h3", text: "Kontaktformular" },
      {
        type: "p",
        text:
          "Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.",
      },
      {
        type: "p",
        text:
          "Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.",
      },
      {
        type: "p",
        text:
          "Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.",
      },

      { type: "h3", text: "Anfrage per E-Mail, Telefon oder Telefax" },
      {
        type: "p",
        text:
          "Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.",
      },
      {
        type: "p",
        text:
          "Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.",
      },
      {
        type: "p",
        text:
          "Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben unberührt.",
      },
    ],
  },

  {
    id: "analyse-werbung",
    title: "5. Analyse-Tools und Werbung",
    blocks: [
      { type: "h3", text: "IONOS WebAnalytics" },
      {
        type: "p",
        text:
          "Diese Website nutzt die Analysedienste von IONOS WebAnalytics (im Folgenden: IONOS). Anbieter ist die 1&1 IONOS SE, Elgendorfer Straße 57, D – 56410 Montabaur.",
      },
      {
        type: "p",
        text:
          "Im Rahmen der Analysen mit IONOS können u. a. Besucherzahlen und –verhalten (z.B. Anzahl der Seitenaufrufe, Dauer eines Webseitenbesuchs, Absprungraten), Besucherquellen (d. h., von welcher Seite der Besucher kommt), Besucherstandorte sowie technische Daten (Browser- und Betriebssystemversionen) analysiert werden.",
      },
      { type: "h4", text: "IONOS speichert insbesondere:" },
      {
        type: "list",
        items: [
          "Referrer (zuvor besuchte Webseite)",
          "angeforderte Webseite oder Datei",
          "Browsertyp und Browserversion",
          "verwendetes Betriebssystem",
          "verwendeter Gerätetyp",
          "Uhrzeit des Zugriffs",
          "IP-Adresse in anonymisierter Form (wird nur zur Feststellung des Orts des Zugriffs verwendet)",
        ],
      },
      {
        type: "p",
        text:
          "Die Datenerfassung erfolgt laut IONOS vollständig anonymisiert, sodass sie nicht zu einzelnen Personen zurückverfolgt werden kann. Cookies werden von IONOS WebAnalytics nicht gespeichert.",
      },
      {
        type: "p",
        text:
          "Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der statistischen Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.",
      },
      {
        type: "p",
        text:
          "Weitere Informationen zur Datenerfassung und Verarbeitung durch IONOS WebAnalytics entnehmen Sie der Datenschutzerklaerung von IONOS.",
      },

      { type: "h3", text: "WordPress Statistik" },
      {
        type: "p",
        text:
          "Diese Website nutzt „WordPress Statistik“, um Besucherzugriffe statistisch auszuwerten. Anbieter ist die Automattic Inc., 60 29th Street #343, San Francisco, CA 94110-4929, USA.",
      },
      {
        type: "p",
        text:
          "WordPress Statistik verwendet Technologien, die die Wiedererkennung des Nutzers zum Zwecke der Analyse des Nutzerverhaltens ermöglichen (z. B. Cookies oder Device-Fingerprinting). WordPress Statistik erfasst zur Analyse u. a. Logdateien (Referrer, IP-Adresse, Browser u. a.), die Herkunft der Websitebesucher (Land, Stadt) und welche Aktionen sie auf der Seite getätigt haben (z. B. Klicks, Ansichten, Downloads). Die so erfassten Informationen über die Benutzung dieser Website werden auf Servern in den USA gespeichert. Ihre IP-Adresse wird nach der Verarbeitung und vor der Speicherung anonymisiert.",
      },
      {
        type: "p",
        text:
          "Die Nutzung dieses Analyse-Tools erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der anonymisierten Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren. Sofern eine entsprechende Einwilligung abgefragt wurde (z. B. eine Einwilligung zur Speicherung von Cookies), erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.",
      },
    ],
  },

  {
    id: "newsletter",
    title: "6. Newsletter",
    blocks: [
      { type: "h3", text: "Newsletterdaten" },
      {
        type: "p",
        text:
          "Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind. Weitere Daten werden nicht bzw. nur auf freiwilliger Basis erhoben.",
      },
      {
        type: "p",
        text:
          "Diese Daten verwenden wir ausschließlich für den Versand der angeforderten Informationen und geben diese nicht an Dritte weiter.",
      },
      {
        type: "p",
        text:
          "Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters können Sie jederzeit widerrufen, etwa über den „Austragen“-Link im Newsletter. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.",
      },
      {
        type: "p",
        text:
          "Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der Abbestellung des Newsletters oder nach Zweckfortfall aus der Newsletterverteilerliste gelöscht.",
      },
      {
        type: "p",
        text:
          "Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in einer Blacklist gespeichert, um künftige Mailings zu verhindern. Die Daten aus der Blacklist werden nur für diesen Zweck verwendet und nicht mit anderen Daten zusammengeführt.",
      },
      {
        type: "p",
        text:
          "Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht befristet. Sie können der Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes Interesse überwiegen.",
      },
    ],
  },

  {
    id: "plugins-tools",
    title: "7. Plugins und Tools",
    blocks: [
      { type: "h3", text: "Font Awesome" },
      {
        type: "p",
        text:
          "Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten und Symbolen Font Awesome. Anbieter ist die Fonticons, Inc., 6 Porter Road Apartment 3R, Cambridge, Massachusetts, USA.",
      },
      {
        type: "p",
        text:
          "Beim Aufruf einer Seite lädt Ihr Browser die benötigten Fonts in ihren Browsercache, um Texte, Schriftarten und Symbole korrekt anzuzeigen. Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Font Awesome aufnehmen. Hierdurch erlangt Font Awesome Kenntnis darüber, dass über Ihre IP-Adresse diese Website aufgerufen wurde.",
      },
      {
        type: "p",
        text:
          "Die Nutzung von Font Awesome erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes auf unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde (z. B. eine Einwilligung zur Speicherung von Cookies), erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit widerrufbar.",
      },
      {
        type: "p",
        text:
          "Wenn Ihr Browser Font Awesome nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.",
      },
      {
        type: "p",
        text:
          "Weitere Informationen zu Font Awesome finden Sie in der Datenschutzerklärung von Font Awesome.",
      },
      { type: "h4", text: "Quelle" },
      { type: "p", text: "https://www.e-recht24.de" },
    ],
  },
];

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ScrollSpy({ activeId, onJump }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-[0_18px_60px_-35px_rgba(15,23,42,0.35)]">
      <div className="border-b border-slate-100 px-5 py-4">
        <div className="text-sm font-bold text-[#0b2b40]">Inhalt</div>
        <div className="mt-1 text-xs text-slate-500">Schnellnavigation</div>
      </div>

      <div className="p-2">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            onClick={() => onJump(s.id)}
            className={cx(
              "w-full rounded-xl px-3 py-2 text-left text-sm transition",
              activeId === s.id
                ? "bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200"
                : "text-slate-700 hover:bg-slate-50"
            )}
          >
            {s.title}
          </button>
        ))}
      </div>
    </div>
  );
}

function Block({ b }) {
  if (b.type === "h3") {
    return <h3 className="mt-2 text-base font-bold text-[#0b2b40]">{b.text}</h3>;
  }
  if (b.type === "h4") {
    return <h4 className="mt-3 text-sm font-bold text-[#0b2b40]">{b.text}</h4>;
  }
  if (b.type === "p") {
    return <p className="text-sm leading-6 text-slate-700">{b.text}</p>;
  }
  if (b.type === "address") {
    return (
      <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
        <div className="text-sm font-semibold text-[#0b2b40]">Adresse</div>
        <div className="mt-2 space-y-1 text-sm text-slate-700">
          {b.lines.map((l, idx) => (
            <div key={idx}>{l || <span className="opacity-0">.</span>}</div>
          ))}
        </div>
      </div>
    );
  }
  if (b.type === "list") {
    return (
      <ul className="list-disc space-y-2 pl-5 text-sm leading-6 text-slate-700">
        {b.items.map((it, idx) => (
          <li key={idx}>{it}</li>
        ))}
      </ul>
    );
  }
  if (b.type === "kv") {
    const value =
      b.valueType === "email" ? (
        <a
          href={`mailto:${b.value}`}
          className="text-[#0b2b40] underline underline-offset-4 decoration-[#0b2b40]/30 hover:decoration-[#0b2b40]"
        >
          {b.value}
        </a>
      ) : (
        <span className="text-slate-700">{b.value}</span>
      );

    return (
      <div className="grid grid-cols-1 gap-2 rounded-xl border border-slate-200 bg-white p-4 md:grid-cols-12 md:gap-4">
        <div className="md:col-span-4">
          <div className="text-sm font-semibold text-[#0b2b40]">{b.label}</div>
        </div>
        <div className="md:col-span-8 text-sm leading-6">{value}</div>
      </div>
    );
  }
  if (b.type === "callout") {
    return (
      <div
        className={cx(
          "rounded-xl border p-4",
          b.tone === "warn"
            ? "border-amber-200 bg-amber-50"
            : "border-slate-200 bg-slate-50"
        )}
      >
        {b.title ? (
          <div className="text-sm font-bold text-[#0b2b40]">{b.title}</div>
        ) : null}
        <p className="mt-2 whitespace-pre-line text-sm leading-6 text-slate-700">
          {b.text}
        </p>
      </div>
    );
  }

  return null;
}

function SectionCard({ section, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section
      id={section.id}
      className="scroll-mt-28 rounded-2xl border border-slate-200 bg-white shadow-[0_18px_60px_-35px_rgba(15,23,42,0.35)]"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-start justify-between gap-6 border-b border-slate-100 px-5 py-4 text-left sm:px-6"
      >
        <div>
          <h2 className="text-base font-bold tracking-tight text-[#0b2b40] sm:text-lg">
            {section.title}
          </h2>
          <div className="mt-1 text-xs text-slate-500">
            Klicken zum {open ? "Schließen" : "Öffnen"}
          </div>
        </div>

        <div className="mt-1 flex items-center gap-2">
          <span className="hidden h-2 w-2 shrink-0 rounded-full bg-emerald-500 sm:block" />
          <span
            className={cx(
              "grid h-8 w-8 place-items-center rounded-xl border border-slate-200 bg-slate-50 text-[#0b2b40] transition",
              open ? "rotate-180" : ""
            )}
            aria-hidden="true"
          >
            ▾
          </span>
        </div>
      </button>

      {open ? (
        <div className="px-5 py-4 sm:px-6">
          <div className="space-y-4">
            {section.blocks.map((b, idx) => (
              <Block key={idx} b={b} />
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default function DataProtection() {
  const [activeId, setActiveId] = useState(SECTIONS[0]?.id || "");

  const sectionIds = useMemo(() => SECTIONS.map((s) => s.id), []);

  // lightweight scrollspy
  React.useEffect(() => {
    const handler = () => {
      let current = sectionIds[0] || "";
      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top <= 140) current = id; // header offset
      }
      setActiveId(current);
    };

    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, [sectionIds]);

  const onJump = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <Navbar />
      <div className="bg-white mt-32">
        <div className="mx-auto w-[90%] 2xl:w-[70%] ">
          {/* Header */}
          <div className="mb-8 rounded-2xl border border-slate-200 bg-gradient-to-b from-slate-50 to-white p-6 shadow-[0_18px_60px_-35px_rgba(15,23,42,0.35)] sm:p-8">
            <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
              Rechtliches
            </div>
            <h1 className="mt-3 h1-mb h1-md h1-lg h1-2xl">
              Datenschutzerklärung
            </h1>
            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600">
              Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO.
            </p>
          </div>

          {/* Layout */}
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
            {/* TOC */}
            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-28">
                <ScrollSpy activeId={activeId} onJump={onJump} />
              </div>
            </div>

            {/* Content */}
            <div className="lg:col-span-8">
              <div className="grid grid-cols-1 gap-6">
                {SECTIONS.map((section, idx) => (
                  <SectionCard
                    key={section.id}
                    section={section}
                    defaultOpen={idx === 0} // first open, rest collapsed
                  />
                ))}
              </div>

              {/* footer source */}
              <div className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 p-5 text-xs leading-5 text-slate-600">
                Quelle:{" "}
                <a
                  className="underline underline-offset-4 decoration-slate-400 hover:decoration-slate-700"
                  href="https://www.e-recht24.de"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.e-recht24.de
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
}
